module.exports = __webpack_public_path__ + "img/1-mile-icon.871030a5.svg";